import React from 'react'

import Icon from './Icon'
import type { IconProps } from './Icon'
import { ReactComponent as PriorityLow } from 'assets/svg/icon-priority-low.svg'

function IconPriorityLow(props: IconProps): JSX.Element {
  const title = 'icon-priority-low'
  const {
    className,
    id = title,
    name = title,
    variants = 'md',
    ...others
  } = props

  const svgProps = { id, name }

  return (
    <Icon className={className} variants={variants} {...others}>
      <PriorityLow {...svgProps} data-testid={title} />
    </Icon>
  )
}

export default IconPriorityLow
